import React from "react";
import Menu from "./components/Menu/Menu";
import UpperMiddleDashBoard from "./components/UpperMiddleDashBoard/UpperMiddleDashBoard";
import SecBarChart from "./components/SecBarChart/SecBarChart";
import FirstBarChart from "./components/FirstBarChart/FirstBarChart";
import LowerMiddleDashBoard from "./components/LowerMiddleDashBoard/LowerMiddleDashBoard";
import LeftTopDashBoard from "./components/LeftTopDashBoard/LeftTopDashBoard";
import LeftMiddleDashBoard from "./components/LeftMiddleDashBoard/LeftMiddleDashBoard";
import LeftBottomDashBoard from "./components/LeftBottomDashBoard/LeftBottomDashBoard";

const App = () => {
  return (
    <>
      <div className="modal">
        <p>
          Not flexible to lower screen size. Please use your Desktop or Laptop
        </p>
      </div>
      <div className="Body"></div>
      <div className="WholeDashboard">
        <Menu />
        <div className="DashBoardMiddle">
          <UpperMiddleDashBoard />
          <div className="TwoBarChart">
            <FirstBarChart />
            <SecBarChart />
          </div>
          <LowerMiddleDashBoard />
        </div>
        <div className="LeftOverAll">
          <LeftTopDashBoard />
          <LeftMiddleDashBoard />
          <LeftBottomDashBoard />
        </div>
      </div>
    </>
  );
};

export default App;
